export default "__VITE_ASSET__7yS3J6VZ__"